import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import postsList from '../data/posts';
import SectionPageTitle from '../components/SectionPageTitle';
import PageNotFound from './PageNotFound';
import SocialShare from '../components/SocialShare';
import Sidebar from '../components/Sidebar';

export default function PostLayout() {
	const { postName } = useParams(),
			post = postsList.filter(post => post.slug.includes(postName))[0];
			
	if (post) {
		return (
			<>
				<Helmet>
					<title>{post.title}</title>
				</Helmet>

				<SectionPageTitle
					pageTitle={post.title}
					subTitle={`${post.date} - ${post.category}`}
					bgImg={post.imgs}
				/>

				<section className="container grid-sidebar">
					<article>
						{post.content}
						
						<SocialShare title={post.title} img={post.imgs.v} />
					</article>

					<Sidebar />
				</section>
			</>
		);
	} else {
		return <PageNotFound />
	}
}
